<template>
  <div>
    <v-card class="box">
      <v-row fluid justify="center">
        <v-radio-group v-model="print_type" row>
          <v-radio label="Print Bulk" value="Bulk" color="success"></v-radio>
          <v-radio
            label="Print Specific"
            value="Specific"
            color="success"
          ></v-radio>
        </v-radio-group>
      </v-row>
      <template v-if="print_type == 'Bulk'">
        <br />
        <v-row dense justify="center" style="align-content: center">
          <v-switch v-model="isEnabled" color="primary" class="mt-0">
          </v-switch>
          <span class="pt-1 pl-2"><b>Reversed Bulk Icard</b></span>
        </v-row>
        <v-row justify="center">
          <v-btn color="primary" @click="bulk"
            >Proceed to bulk <span class="i-card"> Icard </span> print</v-btn
          >
        </v-row>
        <br />
      </template>
      <template v-if="print_type == 'Specific'">
        <br />
        <v-row justify="center" dense>
          <v-col sm="5">
            <v-textarea
              v-model="emp_code"
              color="#0F2027"
              rounded
              dense
              label="Enter Comma Seperated Employee Code"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="emp_code">
          <v-switch v-model="isEnabledSpecific" color="primary" class="mt-0">
          </v-switch>
          <span class="pt-1 mr-8"><b>Reversed Icard</b></span>

          <v-btn color="primary" @click="getSpecificInstructor()" class="mr-8"
            >Proceed To <span class="i-card"> Icard </span> print</v-btn
          >
          <br />
        </v-row>
      </template>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    print_type: null,
    comp_load: false,
    inst_list: null,
    radios: null,
    inst_data: null,
    icard_data: [],
    barcodeValue: "test",
    isEnabled: false,
    isEnabledSpecific: false,
    emp_code: "",
    for: null,
    usertype: null,
  }),
  mounted() {
    this.comp_load = true;
    this.inst_data = null;
    axios
      .post("/RoleManagement/getAllEmployee")
      .then((res) => {
        if (res.data.msg == "200") {
          this.inst_list = res.data.inst_list;
        } else {
          alert("Somthing went wrong!!!");
        }
      })
      .catch((error) => {
        alert("Somthing went wrong!!!");
      })
      .finally(() => {
        this.comp_load = false;
      });
  },
  methods: {
    bulk() {
      localStorage.setItem("isEnabled", this.isEnabled);
      let routeData = this.$router.resolve({
        name: "sbpps-inst-bulk-card-print",
      });
      window.open(routeData.href, "_blank");
    },
    getSpecificInstructor() {
      const data = {
        inst_data: this.emp_code,
        for: "specific",
        usertype: "Employee",
      };
      axios
        .post("/Icard/generateIcardCommon", data)
        .then((res) => {
          this.icard_data = res.data.icard_data;
          localStorage.setItem("isEnabledSpecific", this.isEnabledSpecific);
          localStorage.setItem("icard_data", JSON.stringify(this.icard_data));
          localStorage.setItem("inst_data", JSON.stringify(this.inst_data));
          let routeData = this.$router.resolve({
            name: "sbpps-inst-specific-card-print",
          });
          window.open(routeData.href, "_blank");
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
  },
};
</script>
<style scoped>
.i-card {
  color: greenyellow;
  font-size: medium;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
